import { call, takeLatest } from "redux-saga/effects";
import { NOTIFICATION_LIST } from "../actions/types";
import { notificationListApi } from "../apis/notificationApis";

export function* notificationsListWorker(action) {
  try {
    const res = yield call(notificationListApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* notificationsListWatcher() {
  yield takeLatest(NOTIFICATION_LIST, notificationsListWorker);
}
